export default function initializeRefreshDetector() {
  window.hasRefreshed = sessionStorage.getItem('enteredPreviously') === '1';

  /* Set an entry in the session so that we can detect refresh later */
  sessionStorage.setItem('enteredPreviously', '1');
}
